<template>
    <div>
        <Header title="标签管理">
            <template v-slot:content>
                <div style="display: flex">
                    <div style="flex:1">
                    </div>
                    <div>
                        <Button @click="async_d">同步</Button>
                        <Button style="margin-left:20px" type="primary" @click="add">新增</Button>
                    </div>

                </div>
            </template>
        </Header>
        <div class="my-white-mod">
            <PageTable  :loading="table.loading"  :columns="table.columns"  :size="table.limit"  :data="table.data" :current="table.current" :total="table.total" @switchPage="changepage" >
            </PageTable>
        </div>


        <Modal
                v-model="show_success"
                :title="title"
                width="400"
        >
            <div class="modal-title">标签组</div>
            <Input  placeholder="请填写标签名称"  v-model="submit_form.group_name" />
            <div class="modal-title modal-title-two">排序</div>
            <Input  placeholder="请填写排序"  v-model="submit_form.sort" />
            <div class="modal-title modal-title-two">标签名</div>
            <Row
                    v-for="(item, index) in submit_form.tag"
                    :key="index"
                    style="margin-top:10px"
            >
                    <Col span="15">
                        <Input type="text" v-model="item.name" placeholder="请输入标签名"></Input>
                    </Col>
                    <Col span="3" offset="1">
                        <Input type="text" v-model="item.order" placeholder="序号"></Input>
                    </Col>
                    <Col span="3" offset="1">
                        <Button @click="handleRemove(index)" icon="md-remove"></Button>
                    </Col>
            </Row>
                <Row style="margin-top:10px">
                    <Col span="6">
                        <Button type="dashed" long @click="handleAdd" icon="md-add"></Button>
                    </Col>
                </Row>
            <div slot="footer">
                <Button  type="primary"  @click="update">确定</Button >
            </div>
        </Modal>
        <Modal
                v-model="show_del"
                title="删除"
                width="400"
                @on-ok="delete_tag"
        >
            <div class="my-modal-del">
                <Icon type="ios-alert" />
                是否删除该标签
            </div>
        </Modal>
    </div>

</template>
<script>
    import {tags_list, tags_manager, tags_del, tags_async } from "@/api/system";
    import {Header, PageTable} from "@/components/mainLayout"
    export default {
        components:{
            Header,
            PageTable
        },
        data(){
            return{
                title:"新增",
                show_success:false,
                show_del:false,
                delete_id:0,
                index: 1,
                submit_form:{
                    group_name:"",
                    tag:[]
                },
                table:{
                    current:1,
                    total:50,
                    limit:30,
                    columns: [
                        {
                            align:'center',
                            type: 'index'
                        },
                        {
                            title: '标签组',
                            align:'center',
                            key: 'group_name'
                        },
                        {
                            title: '标签',
                            align:'center',
                            key: 'group_name',
                            render: (h, params) => {
                                var tags = params.row.tag
                                if (typeof params.row.tag == "string") {
                                    tags = JSON.parse(params.row.tag)
                                }
                                var tags_list = []
                                for(var i in tags) {
                                    tags_list.push(tags[i]['name'])
                                }
                                return  h('span', {}, tags_list.join("、"))
                            }
                        },
                        {
                            title: '添加时间',
                            align:'center',
                            key: 'ctime',
                            render: (h, params) => {
                                return h('div', [
                                    h('span', {
                                        style:{color:'#445E87'}
                                    }, params.row.ctime.replace("T", " "))
                                ]);
                            }
                        },
                        {
                            title: '操作',
                            align:'center',
                            key: 'id',
                            render: (h, params) => {
                                return h('div', [
                                    h('Button', {
                                        props: {
                                            type: 'text',
                                            size: 'small'
                                        },
                                        style:{color:'#3F8CFF'},
                                        on: {
                                            click: () => {
                                                this.edit(params)
                                            }
                                        }
                                    }, '编辑'),
                                    h('Button', {
                                        props: {
                                            type: 'text',
                                            size: 'small'
                                        },
                                        style:{color:'#ff0000'},
                                        on: {
                                            click: () => {
                                                this.del(params);
                                            }
                                        }
                                    }, '删除')
                                ]);

                            }

                        }
                    ],
                    data: []
                }

            }
        },
        mounted(){
            this.list()
        },
        methods:{
            handleAdd () {
                this.submit_form.tag.push({
                    name: '',
                    order:this.submit_form.tag.length + 1,
                    status:1
                });
            },
            handleRemove (index) {
                let delete_tag = this.submit_form.tag.splice(index, 1)
                console.log(delete_tag)
                this.submit_form.delete_tag.push(delete_tag[0]['id'])
            },
            list(){
                this.table.loading = true;
                tags_list({limit:this.table.limit, page:this.table.current}).then(res=>{
                    this.table.loading = false;
                    if (res.code == 200) {
                        this.table.data = res.data
                        this.table.total = res.total
                    } else {
                        this.table.data = []
                        this.table.total = 0
                    }
                })
            },
            update(){
                if (this.submit_form.group_name == "" ){
                    this.$Message.error("标签组名称不能为空");return;
                }
                if (this.submit_form.tag.length == 0) {
                    this.$Message.error("标签不能为空");return;
                }
                this.submit_form.tag = this.submit_form.tag.filter(item=> item.name != "")

                this.$Message.info({
                    content: '与企微端数据同步中，请耐心等待',
                    duration: 0
                });
                tags_manager(this.submit_form).then(res=>{
                    this.$Message.destroy()
                    if (res.code == 200) {
                        this.show_success = false
                        this.list();
                        this.$Message.success(res.msg);
                    } else {
                        this.$Message.error(res.msg);
                    }
                })
            },
            delete_tag(){
                this.$Message.info({
                    content: '与企微端数据同步中，请耐心等待',
                    duration: 0
                });
                tags_del({id:this.delete_id}).then(res=>{
                    this.$Message.destroy()
                    if (res.code == 200) {
                        this.list();
                        this.$Message.success(res.msg);
                    } else {
                        this.$Message.error(res.msg);
                    }
                })
            },
            add(){
                this.title = "新增";
                this.show_success = true;
                this.submit_form = {
                    group_name : "",
                    sort:0,
                    tag: [],
                    delete_tag:[]
                };
            },
            edit(e){
                this.submit_form = e.row;
                this.submit_form.tag = JSON.parse( e.row.tag);
                this.submit_form.delete_tag = []
                this.title = "编辑";
                this.show_success = true;
            },
            del(e){
                this.show_del = true;
                this.delete_id = e.row.id;
            },
            changepage(index){
                this.table.current = index;
                this.list();
            },
            async_d(){
                this.$Message.info({
                    content: '与企微端数据同步中，请耐心等待',
                    duration: 0
                });
                tags_async().then(res=>{
                    this.$Message.destroy()
                    if (res.code == 200) {
                        this.list();
                        this.$Message.success(res.msg);
                    } else {
                        this.$Message.error(res.msg);
                    }
                })
            }
        }
    }
</script>
